import { DatePipe } from '@angular/common';
import { inject, Injectable } from '@angular/core';
import { addDays } from 'date-fns';
import { ConfigService } from '../../../../config/data-services/config.abstract.data-service';
import { DottedKey } from '../../../../core/field-definitions/entities/field-definition.entity';
import { ExtendedProfileField } from '../../../../core/profiles/entities/extended-profile-field.entity';
import { ApiFragment } from '../../../../core/records/entities/api-fragment.class';
import { Cell } from '../../components/cells/_base/table-cell.entity';
import { TextCell } from '../../components/cells/text-cell/text-cell.entity';
import { ColumnWidth } from '../../entities/column-width.entity';
import { ProfileFieldColumnService } from '../base-columns/profile-field-column.service';

@Injectable({ providedIn: 'root' })
export class EstimatedPermanentDeleteDateColumnService extends ProfileFieldColumnService<ApiFragment> {
    protected readonly WIDTH: ColumnWidth = ColumnWidth.WIDE;
    protected readonly DISABLE_SORT: boolean = false;

    private readonly DEFAULT_DELETE_RECYCLE_DELAY: number = 180;

    private readonly datePipe: DatePipe = inject(DatePipe);
    private readonly configService: ConfigService<any> = inject(ConfigService);

    private readonly deleteRecycleDelay: number =
        this.configService.getInstant('deleteRecycleDelay') ?? this.DEFAULT_DELETE_RECYCLE_DELAY;

    protected getMapper(profileField: ExtendedProfileField): (item: ApiFragment) => Cell {
        return record => {
            const logicalDeletionDate: Date | null = record.getLogicalDeletionDate();

            if (logicalDeletionDate && this.deleteRecycleDelay) {
                const estimatedPermanentDeleteDate: Date = addDays(logicalDeletionDate, this.deleteRecycleDelay);
                return new TextCell(this.datePipe.transform(estimatedPermanentDeleteDate, 'dd MMM yyyy, HH:mm'));
            }
            return new TextCell('-');
        };
    }

    protected getFieldSelectDottedKeys(profileField: ExtendedProfileField): DottedKey[] {
        return ['Administrative.LogicalDeletionDate'] as DottedKey[];
    }
}
